import React from 'react'
import GuideImg from "../../../components/Svg/GuideImg";
import {H4} from "../../../components/typography";
import styled from "@emotion/styled";
import {useRecoilValue} from "recoil";
import {providerState} from "../../../../atom/simpleCert";
import {providers} from "../../../../constants/simple-cert";

const Container = styled.div`
    width: 100%;
    height: auto;
    min-height: 200px;
    text-align: center;
    margin: 14px auto 48px auto;
`;
const Box = styled.div`
    position: relative;
    width: 200px;
    margin: auto;
    height: auto;
`;

const LogoImage = styled.img`
    width: 24px;
    height: 24px;
    object-fit: cover;
    position: absolute;
    top: 67px;
    left: 43px;
    border-radius: 6px;
`;

export default function PushImage() {
    const provider = useRecoilValue(providerState);
    const text = " 푸시 알림을 확인하여 인증 진행 후\n인증 완료 버튼을 클릭해주세요"

    return (
        <Container>
            <Box>
                <GuideImg width="146" height="146" style={{position: "relative"}}/>
                <LogoImage src={providers[provider].url} alt={providers[provider].text}/>
            </Box>

            <H4 style={{marginTop: "24px"}}>{text}</H4>
        </Container>
    )
}
